import React, { Suspense, lazy } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import FooterComponent from './components/FooterComponent/FooterComponent';
import MobileScreen from './pages/MobileScreen';

const Dashboard = lazy(() => import('./pages/Dashboard/Dashboard'));
const NotFoundPage = lazy(() => import('./pages/404/NotFoundPage'));

type Props = {}
const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
 };
 // Example usage
 if(isMobileDevice()){
  var elementToHide = document.querySelector('.NavigationPanel_headerabcd__irr9Z') as HTMLElement;
    if (elementToHide) {
        elementToHide.style.display = 'none';
    }
 }
function AppRouter(props: Props) {
  return (
    <Router>
       
    {isMobileDevice()?<MobileScreen />:
      <Suspense>
        <Routes>
          <Route path='/edge/dashboard' element={<Dashboard />} />
          <Route path='*' element={<NotFoundPage />} />
          <Route path="/edge/dashboard/error" element={<NotFoundPage />} />
        </Routes>
        {/* <FooterComponent /> */}
      </Suspense>
      
  }
    </Router>
  )
}

export default AppRouter